import $ from 'jquery';
import Reveal from '../vendor/revealLib';

var $next = $('.js-next');
var $prev = $('.js-prev');
var $slides = $('.slides');
var $home = $('[data-js="home"]');
var fr = $('body').hasClass('france');
var region = $('body').attr('data-js-region');

if($next.length){
	$(document).ready(()=>{
		init();
	})
}

function init(){
	Reveal.initialize({
		margin: 0,
		width: 1150,
		height: 800,
		history: true,
		controls: false,
		minScale: 0.7,
		touch: false
	});

	$(Reveal).on('ready',addEventHandlers);

	if(window.localStorage.getItem(region+'-last-slide-indices')) {
		var indices = JSON.parse(window.localStorage.getItem(region+'-last-slide-indices'));
		Reveal.slide(indices['h'],indices['v']);
	}
}

function addEventHandlers(){
	checkState();

	$next.on('click',Reveal.next);
	$prev.on('click',Reveal.prev);

	$(Reveal).on('slidechanged',checkState);
	$(Reveal).on('slidechanged',slideProgress);

}

function checkState(){
	$slides.scrollTop(0);
	if(Reveal.isFirstSlide()){
		$prev.addClass('disabled');
	}else{
		$prev.removeClass('disabled');
	}
	if(Reveal.isLastSlide()){
		$next.addClass('disabled');
		fr ? $home.removeClass('hide') : false;
	}else{
		$next.removeClass('disabled');
		fr ? $home.addClass('hide') : false;
	}
}

function slideProgress(){

	var currentSlideIndex = Reveal.getIndices().h + 1;
  
	$.post(region + '/slide-progress',{
		slide: currentSlideIndex,
		total: Reveal.getTotalSlides(),
		region: region
	});
}